/**
 * Quick View component
 * 
 * @module quick-view
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = 'quick-view';

if(!customElements.get(customElements.component)){
    class quickView extends HTMLElement {

        /**
         * Quick view web component
         * 
         * @constructor
         */
        constructor() {
    
            super();
    
            this.initEvents();
            this.initFocusTrap();

            window.addEventListener('init-quickview', event => {

                this.initEvents();
                this.initFocusTrap();

            });
            
            window.theme.quickView = this;
        }

        /**
         * Init component events.
         * 
         * @returns {undefined}
         */
        initEvents() {

            this.initOpenEvents();
            this.initCloseEvents();
        }

        /**
         * Init quick view open events
         * 
         * @returns {undefined}
         */
        initOpenEvents() {
            let btnsOpen = document.querySelectorAll('[data-quick-view-handle]');

            btnsOpen.forEach(btn => {

                // init-quickview is re-dispatched on every load more and filter, bind each button once
                if (btn.classList.contains('js-quick-view-active')) return;
                btn.classList.add('js-quick-view-active');

                btn.addEventListener('click', event => {
                    event.preventDefault();

                    const oneSize = event.target.dataset.oneSize;
                    const handle = event.target.dataset.quickViewHandle;

                    if(oneSize){

                        window.theme.product.loadProduct(handle, true).then((product) => {
                            if (!product) return;
                            window.theme.cart.add(product.variants[0].id, 1, product).catch(error => {
                                // Variant sold out mid session, drop the stale cache and show it on the button
                                sessionStorage.removeItem(product.handle);
                                // Swap only the label node so the bag icon stays
                                btn.lastChild.textContent = ' Sold Out';
                                btn.setAttribute('disabled', true);
                                console.error(error);
                            });
                        }).catch(error => {
                            console.error(error);
                        });

                    } else { 

                        let content = document.querySelector('[data-quick-view-container]');
                        let productCard = document.querySelector('product-card[data-handle="' + btn.dataset.quickViewHandle + '"]');

                        this.open(handle, content.style.height, productCard.offsetWidth, btn);
                    }

                });
    

            });
        }

        /**
         * Init quick view open events
         * 
         * @returns {undefined}
         */
        initCloseEvents() {
            this.querySelectorAll('[data-quick-view-close]').forEach(element => {
                element.addEventListener('click', event => {
                    event.preventDefault();
                    this.close();
                });
            });

            window.addEventListener('closeQuickView', event => {
                this.close();
            });

            if (window.screenMode == 'desktop-large') {
                window.addEventListener('scroll', () => {

                    setTimeout(() => {
                        let coord = document.querySelector('[data-quick-view-container]').getBoundingClientRect();
                        
                        if ((coord.top <= 0 || coord.bottom >= (window.innerHeight || document.documentElement.clientHeight)) && document.querySelector('.quick-view__overlay').classList.contains('active')) {
                            this.close();
                        }
                    }, 400);

                });
            }

            if (window.screenMode == 'mobile') {

                let touchstartY;
                let touchendY;
                
                document.querySelector("[data-quick-view-container]").addEventListener('touchstart', event => {
                    touchstartY = event.changedTouches[0].screenY;
                }, false);
                
                document.querySelector("[data-quick-view-container]").addEventListener('touchend', event => {
                    touchendY = event.changedTouches[0].screenY;

                    let deltaY = touchendY - touchstartY;
    
                    if (deltaY > 50) {
                        this.close();
                    }
                }, false); 
            }
            
        }

        /**
         * Init the product slider 
         * 
         * @returns {undefined}
         */
        initSlider(product) {

            let slider = this.querySelector('[data-slide-init]');
            let slidesPerView = 1; 

            // A product without photos has no first image to measure
            if(product.images[0]?.aspect_ratio <= 0.7 && window.screenMode == 'mobile') {
                slidesPerView = 1.8;
            } else {
                if (slider?.classList) {
                    slider.classList.add('one-slide');
                }
            }


            if(slider && this.enable_carousel) {

                this.slider = new Swiper(slider, {
                    preloadImages: true,
                    slidesPerView: slidesPerView,
                    spaceBetween: 16,
                    autoHeight: false,
                    lazy: {
                        loadPrevNext: true,
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        dynamicBullets: true
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    on: {
                        init: () => {
                            this.classList.add("active-slider");
                            this.classList.add("loaded");
                        },
                        slideChange: index => {}
                    },
                    centeredSlidesBounds: true
                });

            } else {
                this.classList.add("loaded");
            }
        }

        /**
         * Destroy the product slider 
         *  
         * @returns {undefined}
         */
         destroySlider() {
            if (this.slider && this.enable_carousel) {
                this.slider.destroy();
                this.enable_carousel = false;
                this.classList.remove("active-slider");
            }
        }

        /**
         * Open quick view
         * 
         * @param {string} handle Product handle.
         * @returns {undefined}
         */

        open(handle, height, width, btn) {
            // Check to ensure the required object and method exist
                if (window.theme && window.theme.product && typeof window.theme.product.loadProduct === 'function') {
                if (this.productFetchController) this.productFetchController.abort();
                this.productFetchController = new AbortController();
                window.theme.product.loadProduct(handle, true, this.productFetchController.signal).then(product => {
                    if (!product) return;

                    let quickView = document.querySelector('[data-quick-view-container]');

                    this.loadContent(product,height,width).then(content => {
                        if(quickView && content){
                            quickView.innerHTML = content;

                            document.querySelector('.quick-view__overlay').classList.add('active');

                            this.initSlider(product);

                            this.initCloseEvents();

                            if (window.screenMode == 'desktop-large') {
                                let productCard = document.querySelector('product-card[data-handle="' + handle + '"]');

                                this.querySelector('.quick-view__image-wrapper').style.height = productCard.offsetHeight + 'px';
                                this.querySelector('.swiper-wrapper').style.height = productCard.offsetHeight + 'px';
                                this.querySelector('.quick-view__image-wrapper').style.width = productCard.offsetWidth + 'px';

                                // this.querySelectorAll('img').forEach(img => {
                                //     img.style.height = productCard.offsetHeight + 'px';
                                // });
                            }

                            this.classList.add('active');
                            this.setAttribute('aria-hidden', 'false');
                            this.activeFocusTrap();
                            this.initQtySelector();
                            
                            // Initialize stock level component for quick-view
                            this.initStockLevel(product);

                            let container = document.querySelector('[data-quick-view-container]');
                            let productCard = document.querySelector('product-card[data-handle="' + btn.dataset.quickViewHandle + '"]');
                            
                            if(window.screenMode == 'tablet' || window.screenMode == 'desktop' && btn.dataset.minicart != 'true') {
                                container.style.left = 'auto';
                                container.style.right = '0px';

                            } else if (window.screenMode == 'desktop-large' && btn.dataset.minicart != 'true') {
                                let coord = productCard.getBoundingClientRect();

                                if (coord.left + (productCard.offsetWidth * 2) > window.innerWidth) {
                                    container.style.left = coord.left - productCard.offsetWidth - 34 + 'px';
                                } else {
                                    container.style.left = coord.left + 'px';
                                }

                                container.style.top = coord.top + 'px';
                                container.style.height = productCard.offsetHeight + 'px';
                                container.style.width = productCard.offsetWidth  + 'px';

                                
                                container.style.width = (productCard.offsetWidth * 2)  + 34 + 'px';
                                let form = this.querySelector('[data-quick-view-form]'); 
                                
                                if(form){
                                    form.classList.add('move');
                                }

                                window.addEventListener('scroll', () => {
                                    coord = productCard.getBoundingClientRect();
                                    container.style.top = coord.top + 'px';
                                });

                                const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

                                window.scrollTo({
                                    top: (scrollTop + coord.top) - 150,
                                    behavior: 'smooth'
                                });
                                    
                            }
                        }
                    }).catch(error => {
                        console.error(error);
                    });
        
                }).catch(error => {
                    console.error(error);
                });
            } else {
                // Handle the case where the dependency is missing
                console.warn('The "window.theme.product.loadProduct" object is not available.');
            }
        }

        /**
         * Close quick view
         * 
         * @returns {undefined}
         */
        close() {

            if (this.productFetchController) {
                this.productFetchController.abort();
                this.productFetchController = null;
            }

            this.disableFocusTrap();
            
            // Clean up variant change listener
            if (this.variantChangeHandler) {
                window.removeEventListener('variant-change', this.variantChangeHandler);
                this.variantChangeHandler = null;
            }

            setTimeout(() => {

                this.destroySlider();

                let content = document.querySelector('.quick-view__content');

                if (content) {
                    content.remove();
                    this.setAttribute('aria-hidden', 'true');
                }

                document.querySelector('body').classList.remove('quick-view-active');
                
                document.querySelector('.quick-view__overlay').classList.remove('active');
                if (window.screenMode != 'desktop-large') {
                    document.body.style.overflow = 'auto';
                }

                this.classList.remove('loaded');
                this.classList.remove('active');

            }, 400);
        }
        
        /**
         * Initialize stock level component in quick view
         * 
         * @param {object} product Product data
         * @returns {undefined}
         */
        initStockLevel(product) {
            const stockContainer = this.querySelector('[data-stock-container]');
            if (!stockContainer) return;
            
            // Find the product card on the page
            const productCard = document.querySelector(`product-card[data-handle="${product.handle}"]`);
            if (!productCard) return;
            
            // Copy stock level elements from the product card
            const stockLevelWrappers = productCard.querySelectorAll('.product-card__variant-stocklevel-wrapper');
            
            if (stockLevelWrappers.length > 0) {
                // Clone the stock level elements and add to quick-view
                stockLevelWrappers.forEach((wrapper) => {
                    try {
                        const clonedWrapper = wrapper.cloneNode(true);
                        const variantId = wrapper.getAttribute('data-variant-stocklevel');
                        
                        // Update classes for quick-view styling
                        clonedWrapper.className = 'variant-stocklevel-wrapper';
                        clonedWrapper.setAttribute('data-variant-stocklevel', variantId);
                        
                        // Hide all initially, will show the first variant after
                        clonedWrapper.classList.add('hidden');
                        
                        // Update the stock level component class if it exists
                        const stockComponent = clonedWrapper.querySelector('stocklevel-component');
                        if (stockComponent) {
                            stockComponent.className = 'product-form__stocklevel quick-view__stocklevel';
                        }
                        
                        stockContainer.appendChild(clonedWrapper);
                        
                    } catch (error) {
                        console.log('Error in cloning stockLevelWrappers node: ', error)
                    }
                });
                
                // Show the first variant's stock level
                const firstVariantId = product.variants[0].id;
                const firstWrapper = stockContainer.querySelector(`[data-variant-stocklevel="${firstVariantId}"]`);
                if (firstWrapper) {
                    firstWrapper.classList.remove('hidden');
                }
                
                // Listen for variant changes to show/hide appropriate stock level
                this.variantChangeHandler = (event) => {
                    if (event.detail && event.detail.variant && event.detail.variant.id && event.detail.product && event.detail.product.handle === product.handle) {
                        const variantId = event.detail.variant.id;
                        
                        // Show/hide the appropriate variant stock level wrapper
                        const wrappers = stockContainer.querySelectorAll('.variant-stocklevel-wrapper');
                        wrappers.forEach(wrapper => {
                            const wrapperId = wrapper.getAttribute('data-variant-stocklevel');
                            if (wrapperId == variantId) {
                                wrapper.classList.remove('hidden');
                            } else {
                                wrapper.classList.add('hidden');
                            }
                        });
                    }
                };
                
                window.addEventListener('variant-change', this.variantChangeHandler);
            } else {
                // For products without size options, check if there's a single stock level
                const singleStockLevel = productCard.querySelector('stocklevel-component');
                if (singleStockLevel) {
                    const clonedStock = singleStockLevel.cloneNode(true);
                    clonedStock.className = 'product-form__stocklevel quick-view__stocklevel';
                    stockContainer.appendChild(clonedStock);
                }
            }
        }

        /**
         * Load quick view content
         * 
         * @param {object} product Product data.
         * @returns {string} HTML code
         */
        loadContent(product,height,width) {
            return new Promise((resolve, reject) => {
                let content = window.quickViewTemplate.quick_view_content_layout;
                    width = width + 100;
                    height = document.querySelector("product-card[data-handle='" + product.handle + "']").offsetHeight;

                let productImages = '';

                product.images.forEach(image => { 
                    let src = image.src;
                    let ext = window.theme.file.getExtension(src);
                    let imageSize = '500x' + parseInt(500 / product.images[0].aspect_ratio);

                    // Check if src is defined before attempting to replace
                    if (src) {
                        image.src = src.replace(new RegExp(ext), '_' + imageSize + '_crop_top' + ext);
                    }
      
                    // image.src = src.replace(new RegExp(ext), '_' + imageSize + '_crop_top' + ext);  

                    // productImages += `<div class="swiper-slide quick-view__carousel-item" data-carousel-item-photo><img height="${image.height}" width="${image.width}" src="${image.src}" alt="${image.alt}" loading="lazy"/></div>`;
                    // productImages += `<div class="swiper-slide quick-view__carousel-item" data-carousel-item-photo><img src="${image.src}" alt="${image.alt}" loading="lazy" class="quick-view-img"/></div>`;
                    productImages += `<div class="swiper-slide quick-view__carousel-item" data-carousel-item-photo><img src="${image.src}" alt="${image.alt}" loading="lazy" style="height:100%;width:auto;object-fit:cover;" /></div>`;



                });

                if(product.images.length > 1) {
                    this.enable_carousel = true;
                }

                content = content.replace(/{{productImage}}/g, productImages);
                
                content = content.replace(/{{productTitle}}/g, product.title);

                let product_price = `<span class="quick-view__price-current" data-price>${window.theme.money.format(product.variants[0].price)}</span>`;

                if (product.variants[0].compare_at_price > 0) {
                    product_price += `<span class="quick-view__price-compared" data-compareatprice>${window.theme.money.format(product.variants[0].compare_at_price)}</span>`;
                }
                
                content = content.replace(/{{productPrice}}/g, product_price);
                
                content = content.replace(/{{productId}}/g, product.id);
                
                content = content.replace(/{{variant}}/g, product.variants[0].id);

                content = content.replace(/{{productHandle}}/g, product.handle);

                resolve(content);
            });
        }

        /**
         * Init quick view focus trap
         * 
         * @returns {undefined}
         */
        initFocusTrap() {
            this.focusTrap = focusTrap.createFocusTrap(this, {});
        }

        /**
         * Disable quick view focus trap
         *  
         * @returns {undefined}
         */
        disableFocusTrap() {
            if (this.focusTrap) {
                this.focusTrap.deactivate();
            }
        }

        /**
         * Ative quick view focus trap
         * 
         * @returns {undefined}
         */
        activeFocusTrap() {
            if (this.focusTrap) {
                this.focusTrap.activate();
            }
        }

        /**
         * Init quantity selector
         * 
         * @return {undefined}
         */

        initQtySelector() {

            let QtySelector = this.querySelectorAll('[data-quantity-selector]');
    
            QtySelector.forEach(element => {
    
                element.querySelector('[data-quantity-selector-minus]').addEventListener('click', event => {
    
                    event.preventDefault();
    
                    let input = event.target.parentElement.querySelector('input');
    
                    this.decreaseQtySelector(input);
                });
    
                element.querySelector('[data-quantity-selector-plus]').addEventListener('click', event => {
    
                    event.preventDefault();
    
                    let input = event.target.parentElement.querySelector('input');
    
                    this.increaseQtySelector(input);
                });
            });
        }

        /**
         * Decrease input value
         * 
         * @param {input} input A input for the quantity selector.
         * @return {undefined}
         */

        decreaseQtySelector(input) {

            let value = parseInt(input.value);

            if (value > 0) {

                value--;

                input.value = value;

                let event = new CustomEvent('change', {'detail': input });

                input.dispatchEvent(event);
            }
        }

        /**
         * Increase input value
         * 
         * @param {input} input A input for the quantity selector.
         * @return {undefined}
         */

         increaseQtySelector(input) {

            let value = parseInt(input.value);

            value++;

            input.value = value;

            let event = new CustomEvent('change', {'detail': input });
                
            input.dispatchEvent(event);
        }

    }

    customElements.define(customElements.component, quickView);    
}


